import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @Input() title = 'Segunda Opinión Médica';
  myTitulo:string = 'Segunda Opinión Médica';
  myDate:any;

  constructor() {
   var date : any = new Date();
   date = date.toLocaleDateString("es-ES",{
      year:'numeric',month: 'long', day: 'numeric'
    });
    this.myDate = `${date.split(" ")[2]} ${date.split(" ")[0]}, ${date.split(" ")[4]}`;
  }

  ngOnInit() {
    if(this.title !== undefined){
      this.myTitulo = this.title;
    }

  }

  refresh = function () {
    location.reload();
  }

  openReport = function () {
    window.open(`http://s461-sbrdb01/Reports/Pages/Folder.aspx?ItemPath=%2fSeguros+Masivos%2fSegunda+Opinion+Medica&ViewMode=Detail`);
};
}
